import ListContractsCandidates from './ListContractsCandidates';

export default ListContractsCandidates;
